import React from 'react';
import { ISelectedOptions } from './interfaces';
import SelectedOptionsChip from './SelectedOptionChip';
import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import cx from 'classnames';

const SelectedOptions: React.FC<ISelectedOptions> = ({
  selectedOptions,
  maxSelectedChipToShow = 4,
  disabled,
  wrapperClasses = '',
  labelClasses = '',
  IconColor,
  onOptionClick
}) => {
  return (
    <div
      className={cx(styles.selectedOptions, {
        [styles.disabled]: disabled
      })}
    >
      {selectedOptions.slice(0, maxSelectedChipToShow).map(option => (
        <SelectedOptionsChip
          key={option.value}
          option={option}
          onOptionClick={onOptionClick}
          wrapperClasses={wrapperClasses}
          labelClasses={labelClasses}
          IconColor={IconColor}
        />
      ))}
      {selectedOptions.length > maxSelectedChipToShow && (
        <Typography variant="p3" className={styles.moreText}>
          +{selectedOptions.length - maxSelectedChipToShow} more
        </Typography>
      )}
    </div>
  );
};

export default SelectedOptions;
